var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mapHotlineStatusToSteps)?_c('div',{staticClass:"form-steps"},[_c('div',{staticClass:"form-steps__display",style:(_vm.style)},[_vm._v(_vm._s(_vm.mapHotlineStatusToSteps.step)+" / "+_vm._s(_vm.mapHotlineStatusToSteps.max))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }